import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($options.hasLeftPositionProperty)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["z-1 absolute left-0 top-0 flex flex-col gap-y-8 text-center text-12 font-medium text-white", $options.marginLeft])
        }, [
          ('available' in $props.product && !$props.product.available)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["badge badge-small badge-rounded rounded bg-black-400", _ctx.$attrs.class])
              }, _toDisplayString($data.tags.sold_out.text), 3))
            : _createCommentVNode("", true),
          ($props.product.tags.includes('sale') && $data.tags.sale.enabled && $data.tags.sale.position === 'left')
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(["badge badge-small badge-rounded", _ctx.$attrs.class]),
                style: _normalizeStyle({backgroundColor: $data.tags.sale.bg_color, color: $data.tags.sale.text_color})
              }, _toDisplayString($data.tags.sale.text), 7))
            : _createCommentVNode("", true),
          ($props.product.tags.includes('bonus') && $data.tags.bonus.enabled && $data.tags.bonus.position === 'left')
            ? (_openBlock(), _createElementBlock("span", {
                key: 2,
                class: _normalizeClass(["badge badge-small badge-rounded", _ctx.$attrs.class]),
                style: _normalizeStyle({backgroundColor: $data.tags.bonus.bg_color, color: $data.tags.bonus.text_color})
              }, _toDisplayString($data.tags.bonus.text), 7))
            : _createCommentVNode("", true),
          ($props.product.tags.includes('new') && $data.tags.new.enabled && $data.tags.new.position === 'left')
            ? (_openBlock(), _createElementBlock("span", {
                key: 3,
                class: _normalizeClass(["badge badge-small badge-rounded", _ctx.$attrs.class]),
                style: _normalizeStyle({backgroundColor: $data.tags.new.bg_color, color: $data.tags.new.text_color})
              }, _toDisplayString($data.tags.new.text), 7))
            : _createCommentVNode("", true),
          (
        $props.product.tags.includes('early-access') &&
        $data.tags.early_access.enabled &&
        $data.tags.early_access.position === 'left'
      )
            ? (_openBlock(), _createElementBlock("span", {
                key: 4,
                class: _normalizeClass(["badge badge-small badge-rounded", _ctx.$attrs.class]),
                style: _normalizeStyle({backgroundColor: $data.tags.early_access.bg_color, color: $data.tags.early_access.text_color})
              }, _toDisplayString($data.tags.early_access.text), 7))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    ($options.hasRightPositionProperty)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["z-1 absolute right-0 top-0 flex flex-col items-end gap-y-8 text-center text-12 font-medium text-white", $options.marginRight])
        }, [
          ($props.collectionKitDiscountPercentage > 0)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["badge badge-small badge-rounded text-inherit", _ctx.$attrs.class]),
                style: _normalizeStyle({backgroundColor: $data.tags.discount.bg_color, color: $data.tags.discount.text_color})
              }, " -" + _toDisplayString($props.collectionKitDiscountPercentage) + "% ", 7))
            : ($props.product.compare_at_price > $props.product.price && $props.product.tags.includes('discount'))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["badge badge-small badge-rounded text-inherit", _ctx.$attrs.class]),
                  style: _normalizeStyle({backgroundColor: $data.tags.discount.bg_color, color: $data.tags.discount.text_color})
                }, _toDisplayString($options.discountTag) + "% ", 7))
              : (
        $props.product.compare_at_price > $props.product.price &&
        $props.product.tags.find((tag) => tag.includes('fixed-discount'))
      )
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    class: _normalizeClass(["badge badge-small badge-rounded", _ctx.$attrs.class]),
                    style: _normalizeStyle({backgroundColor: $data.tags.discount.bg_color, color: $data.tags.discount.text_color})
                  }, _toDisplayString($options.fixedDiscountTag), 7))
                : _createCommentVNode("", true),
          ($props.product.tags.includes('sale') && $data.tags.sale.enabled && $data.tags.sale.position === 'right')
            ? (_openBlock(), _createElementBlock("span", {
                key: 3,
                class: _normalizeClass(["badge badge-small badge-rounded", _ctx.$attrs.class]),
                style: _normalizeStyle({backgroundColor: $data.tags.sale.bg_color, color: $data.tags.sale.text_color})
              }, _toDisplayString($data.tags.sale.text), 7))
            : _createCommentVNode("", true),
          ($props.product.tags.includes('bonus') && $data.tags.bonus.enabled && $data.tags.bonus.position === 'right')
            ? (_openBlock(), _createElementBlock("span", {
                key: 4,
                class: _normalizeClass(["badge badge-small badge-rounded", _ctx.$attrs.class]),
                style: _normalizeStyle({backgroundColor: $data.tags.bonus.bg_color, color: $data.tags.bonus.text_color})
              }, _toDisplayString($data.tags.bonus.text), 7))
            : _createCommentVNode("", true),
          ($props.product.tags.includes('new') && $data.tags.new.enabled && $data.tags.new.position === 'right')
            ? (_openBlock(), _createElementBlock("span", {
                key: 5,
                class: _normalizeClass(["badge badge-small badge-rounded", _ctx.$attrs.class]),
                style: _normalizeStyle({backgroundColor: $data.tags.new.bg_color, color: $data.tags.new.text_color})
              }, _toDisplayString($data.tags.new.text), 7))
            : _createCommentVNode("", true),
          (
        $props.product.tags.includes('early-access') &&
        $data.tags.early_access.enabled &&
        $data.tags.early_access.position === 'right'
      )
            ? (_openBlock(), _createElementBlock("span", {
                key: 6,
                class: _normalizeClass(["badge badge-small badge-rounded", _ctx.$attrs.class]),
                style: _normalizeStyle({backgroundColor: $data.tags.early_access.bg_color, color: $data.tags.early_access.text_color})
              }, _toDisplayString($data.tags.early_access.text), 7))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}